import type {
  HandoffSnapshotField,
  HandoffSnapshotFieldKey,
  MarketplaceOrderHandoffSnapshot,
} from "@nexus/contracts";

export const FIELD_LABELS: Record<HandoffSnapshotFieldKey, { key: string; fallback: string }> = {
  orderInstructions: {
    key: "marketplace.sendHandoff.orderNoteTitle",
    fallback: "Order-specific instructions",
  },
  productAccuracy: {
    key: "marketplace.handoff.fields.productAccuracy.label",
    fallback: "Product accuracy",
  },
  brandGuidelines: {
    key: "marketplace.handoff.fields.brandGuidelines.label",
    fallback: "Brand guidelines",
  },
  techSpecs: {
    key: "marketplace.handoff.fields.techSpecs.label",
    fallback: "Tech specs",
  },
  policyRestrictions: {
    key: "marketplace.handoff.fields.policyRestrictions.label",
    fallback: "Policy & restrictions",
  },
  dosAndDonts: {
    key: "marketplace.handoff.fields.dosAndDonts.label",
    fallback: "Do's & Don'ts",
  },
  fontsLicenceProof: {
    key: "marketplace.handoff.fields.fontsLicenceProof.label",
    fallback: "Fonts + licence proof",
  },
  coloursHex: {
    key: "marketplace.handoff.fields.coloursHex.label",
    fallback: "Colours / hex",
  },
  logos: {
    key: "marketplace.handoff.fields.logos.label",
    fallback: "Logos",
  },
  thumbnailGuidelines: {
    key: "marketplace.handoff.fields.thumbnailGuidelines.label",
    fallback: "Thumbnail guidelines",
  },
};

export function snapshotFieldForKey(
  snapshot: MarketplaceOrderHandoffSnapshot,
  key: HandoffSnapshotFieldKey,
): HandoffSnapshotField {
  if (key === "orderInstructions") return snapshot.orderInstructions;
  if (key === "productAccuracy") return snapshot.productAccuracy;
  if (key === "brandGuidelines") return snapshot.rules.brandGuidelines;
  if (key === "techSpecs") return snapshot.rules.techSpecs;
  if (key === "policyRestrictions") return snapshot.rules.policyRestrictions;
  if (key === "dosAndDonts") return snapshot.rules.dosAndDonts;
  if (key === "fontsLicenceProof") return snapshot.brandKit.fontsLicenceProof;
  if (key === "coloursHex") return snapshot.brandKit.coloursHex;
  if (key === "logos") return snapshot.brandKit.logos;
  return snapshot.thumbnailGuidelines ?? { value: "", source: "org_default" };
}
